import axios from "axios";

// ✅ Base configuration for API
const api = axios.create({
  baseURL: "https://hrgf.salepatner.com", // Django backend base URL
});

// Example: GET request wrapper
export const getMessage = async () => {
  try {
    const response = await api.get("/"); // Django root endpoint
    return response.data.message; // return only the message field
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};

export default api;
